<div class="col-md-4 sidebar">
    <div id="ms_login_area-2" class="widget-main">
        <div class="widget-inner">

            <form [formGroup]="loginForm" (ngSubmit)="login()" role="form" class="form-horizontal login-form">
                <div class="form-group">
                    <label class="sr-only">Email Adresse</label>
                    <div class="col-sm-12">
                        <input formControlName="username" class="ms-form-text" type="email" name="l_email" placeholder="Email Adresse">
                    </div>
                </div>

                <div class="form-group">
                    <label class="sr-only">Passwort</label>
                    <div class="col-sm-12">
                        <input formControlName="password" class="ms-form-text" type="password" name="l_password" placeholder="Passwort">
                    </div>
                </div>

                <input [disabled]="!loginForm.valid" class="btn btn-primary btn-block" type="submit" name="submit_login" value="Login">

            </form>
            <ul class="login-form-information">

                <li>
                    <fa-icon [icon]="['fas', 'angle-double-right']" class="list-icon"></fa-icon>
                    <a routerLink="/meinedaten" routerLinkActive="activeLoginLink">Noch nicht registriert?</a>
                </li>
                <li>
                    <fa-icon [icon]="['fas', 'angle-double-right']" class="list-icon"></fa-icon>
                    <a routerLink="/passwortvergessen" routerLinkActive="activeLoginLink">Passwort vergessen?</a>
                </li>
            </ul>
        </div>

    </div>
</div>
